// extracted by mini-css-extract-plugin
module.exports = {"factorajeContainer":"styles_factorajeContainer__w0XMI"};